import {
    IMessageHistory,
    IClaimedMessageJson,
} from "../../../../../nodeserver/structs/database.js";
import JSX from "./../../helpers/react.js";
import { appearClass} from "../../messages/helpers.js";
import {ActionOwnerProfileLink, ActionStatus, HistoryContainerElement, SignType} from "./history-elements.js";
import {ClaimReason, ClaimUserAvatar, getClassForClaimContainer} from "./claim.js";





function getClassNameForHistoryContainer(el: IMessageHistory){
    
    switch(el.change_type){
        case "add":
        case "restore":
            return "circle green-bg";
        case "delete":
            return "circle red-bg";
        case "edit":
            return "circle yellow-bg";
        default:
            return "";
    }
    
}


function SelfMessageSign(){
    return <span className="white-text">своё&nbsp;</span>;
}



function NickName(props:{
    id: number,
    nickname: string
}){
    return <a href={`/users/id${props.id}`}>
        <span className="nickname-color">{props.nickname}&nbsp;</span>
    </a>
}



function Text(props:{
    text:string
}){
    return <div className="text">{props.text}</div>;
}





function ActionDate(props:{
    date: number
}){
    const localTime: HTMLElement = <local-time data-preposition="true" data-time={props.date}/>;
    return <div className="action-date">{localTime.innerHTML}</div>
}


function ActionIndicator(props: {
    imgSrc:string,
    actionClass: string
}){
    return <div className="type-indicator-container">
        <div className="type-indicator">
            <img className="svg-action" src={props.imgSrc}/>
            <div
                className={props.actionClass}/>
        </div>
    </div>
}


function Action(props:{
    nickname:string,
    userId: number,
    ownerNick:string,
    isOnlySignType:boolean
}){
    return(<>
        {!!(props.ownerNick === props.nickname && !props.isOnlySignType) && <SelfMessageSign />}
        <SignType />
        {!!(props.ownerNick !== props.nickname && !props.isOnlySignType) && <NickName id={props.userId} nickname={props.ownerNick}/>}
    </>)
}

function ClaimContainerData({el, i}: { el: IClaimedMessageJson, i: number }) {

    const containerData = (
        <HistoryContainerElement
            firstBlock={[
                <ActionIndicator actionClass={getClassForClaimContainer(el)} imgSrc="/img/white-report.svg"/>,
                <ActionDate date={el.date_complaints}/>
            ]}
            actions={[
                <ActionOwnerProfileLink nickname={el.nickname} userId={el.user_id}/>,
                <ActionStatus el={el.status_complaints}/>,

                <Action
                    isOnlySignType = {false}
                    nickname={el.nickname}
                    ownerNick={el.message.owner.nickname}
                    userId={el.message.owner.id}
                />,
                <ClaimReason el={el}/>,
            ]}
            dataElements={[
                <Text text={el.message.text}/>
            ]}
            iterator={i}
            prefix="r"
            className="report"
            additionalBlocks={[
                <ClaimUserAvatar el={el}/>
            ]}
        />
    );
    return containerData;
}

function HistoryContainerActionElement(props: {
    el: IMessageHistory,
    nickname: string,
    i: number
}) {
    const el = props.el;
    const nickname = props.nickname;
    const i = props.i;
    return (
        <HistoryContainerElement 
            firstBlock={[
                <ActionIndicator actionClass={getClassNameForHistoryContainer(el)} imgSrc="/img/message-icon.svg"/>,
                <ActionDate date={el.date} />
            ]}
            actions={[
                <ActionOwnerProfileLink nickname={el.nickname} userId={el.user_id}/>,
                <ActionStatus el={el}/>,
                <Action 
                    isOnlySignType = {el.change_type === "add"}
                    nickname={nickname}
                    ownerNick={el.nickname}
                    userId={el.user_id}
                />
            ]}
            dataElements={[
                <Text text={el.change_type === "edit" ? el.new_text! : el.old_text!}/>
            ]}
            iterator={i}
            prefix="u"
        />
    );
}


function closeHistoryClickEvent() {
    removeElementToMessageWrapper()
}


function removeElementToMessageWrapper() {
    $(".message-history-container").removeClass(appearClass);

    setTimeout(() => {
        $(".messages-container-wrapper .message-history-container").remove();
    }, 500)
}



export function MessageHistory(props: {
    history: IMessageHistory[],
    messsageId: number,
    nickname: string,
    from_id: number
}) {
    const messsageId = props.messsageId;
    const history = props.history;
    const nickname = props.nickname;
    const from_id = props.from_id;
    return (
        <div className="message-history-container">
            <div className="header">
                <div className="text">
                    <span className="white-text">ИСТОРИЯ СООБЩЕНИЯ </span>
                    <span className="gray-text">#{messsageId} </span>
                    <span className="white-text">от </span>
                    <a href={`/users/id${from_id}`}>
                        <span className="nickname-color">{nickname}</span>
                    </a>
                </div>
                <div className="fa fa-times-circle"
                    onClick={() => closeHistoryClickEvent()}
                ></div>
            </div>
            <div className="actions-message-container gray-text">
                {...history.map((el, i) => {
                    return (
                        <HistoryContainerActionElement el={el} i={i} nickname={nickname}/>
                    );
                })}
            </div>
            
        </div>
    );
}




